// Chart utility functions for bubble charts

/**
 * Determine if current user is a winner for a specific game
 * @param {string} gameId - Game ID to check
 * @param {Object} user - User object with id property
 * @param {Array} timelineData - Timeline data with sessions
 * @returns {boolean} - True if user won any session for this game
 */
export const isUserWinnerForGame = (gameId, user, timelineData) => {
  if (!user || !timelineData || !Array.isArray(timelineData) || !gameId) {
    return false;
  }

  // Find all sessions for this game
  const gameSessions = timelineData.flatMap(dayEntry =>
    (dayEntry.sessions || []).filter(session => session.game_id === gameId)
  );

  return isUserWinnerForGameInSessions(gameId, user, gameSessions);
};

export const isUserWinnerForGameInSessions = (gameId, user, gameSessions) => {
  if (!gameSessions || gameSessions.length === 0) {
    return false;
  }

  // Check if user is a winner in any session for this game
  return gameSessions.some(session => {
    if (!session.winners || !Array.isArray(session.winners)) {
      return false;
    }

    // Simple check: user is in winners array (excluding system dummy user 0)
    return session.winners.includes(user.id) && user.id !== 0;
  });
};
